import React from 'react';
import styled, { css } from 'styled-components';

export const StyledText = styled(({ as: Element = 'span', props, ...rest }) => (
  <Element {...rest} />
))`
  ${props =>
    props.mobileDesign &&
    Object.entries(props.mobileDesign).map(
      ([property, value]) => css`
        ${property}: ${value};
      `
    )} @media screen and (min-width: 40em) {
    ${props =>
      props.tabletDesign &&
      Object.entries(props.tabletDesign).map(
        ([property, value]) => css`
          ${property}: ${value};
        `
      )};
  }

  ${props =>
    props.truncateLines &&
    css`
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: ${props.truncateLines};
      -webkit-box-orient: vertical;
    `};

  @media screen and (min-width: 64em) {
    ${props =>
      props.desktopDesign &&
      Object.entries(props.desktopDesign).map(
        ([property, value]) => css`
          ${property}: ${value};
        `
      )};
  }
`;

export const StyledImage = styled.img`
  width: ${props => props.width || '100%'};
  height: ${props => props.height || 'auto'};
  border-radius: ${props => props.borderRadius || '0'};
`;

export const StyledCard = styled.div`
  ${props => {
    const {
      showPlayIcon,
      theme: { media }
    } = props;
    return css`
      a {
        display: flex;
        flex-direction: column;
        gap: 6px;
      }

      .card_image_container {
        margin-bottom: 14px;

        ${showPlayIcon &&
          css`
            &::after {
              background: url('https://images.fastcompany.net/image/upload/v1501603685/play-button-60px-fix.svg')
                no-repeat center center;
              background-size: 50px;
              content: '';
              height: 100%;
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              z-index: 1;
            }

            ${media.md.up} {
              &::after {
                background-size: 40px;
              }
            }
          `};
      }
    `;
  }};
`;
